// extracted by mini-css-extract-plugin
export var actionText = "_r2-4";
export var container = "_r2-0";
export var leftSection = "_r2-1";
export var rightSection = "_r2-2";
export var settingsButton = "_r2-6";
export var settingsIcon = "_r2-7";
export var shortcut = "_r2-5";
export var shortcutGroup = "_r2-3";